import { render, staticRenderFns } from "./EditorFormField.vue?vue&type=template&id=078b348f&"
import script from "./EditorFormField.vue?vue&type=script&lang=js&"
export * from "./EditorFormField.vue?vue&type=script&lang=js&"
import style0 from "./EditorFormField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EditorFormField.vue"
export default component.exports